import _defineProperty from "/codebuild/output/src2648725416/src/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/codebuild/output/src2648725416/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/codebuild/output/src2648725416/src/node_modules/@babel/runtime/regenerator/index.js";

/**
 * Given an AsyncIterable and a callback function, return an AsyncIterator
 * which produces values mapped via calling the callback function.
 */
export function mapAsyncIterator(iterable, callback) {
  var iterator = iterable[Symbol.asyncIterator]();

  function mapResult(_x) {
    return _mapResult.apply(this, arguments);
  }

  function _mapResult() {
    _mapResult = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(result) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (!result.done) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return", result);

          case 2:
            _context4.prev = 2;
            _context4.next = 5;
            return callback(result.value);

          case 5:
            _context4.t0 = _context4.sent;
            return _context4.abrupt("return", {
              value: _context4.t0,
              done: false
            });

          case 9:
            _context4.prev = 9;
            _context4.t1 = _context4["catch"](2);

            if (!(typeof iterator.return === 'function')) {
              _context4.next = 19;
              break;
            }

            _context4.prev = 12;
            _context4.next = 15;
            return iterator.return();

          case 15:
            _context4.next = 19;
            break;

          case 17:
            _context4.prev = 17;
            _context4.t2 = _context4["catch"](12);

          case 19:
            throw _context4.t1;

          case 20:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[2, 9], [12, 17]]);
    }));
    return _mapResult.apply(this, arguments);
  }

  return _defineProperty({
    next: function next() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = mapResult;
              _context.next = 3;
              return iterator.next();

            case 3:
              _context.t1 = _context.sent;
              return _context.abrupt("return", (0, _context.t0)(_context.t1));

            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    return: function _return() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(typeof iterator.return === 'function')) {
                _context2.next = 8;
                break;
              }

              _context2.t1 = mapResult;
              _context2.next = 4;
              return iterator.return();

            case 4:
              _context2.t2 = _context2.sent;
              _context2.t0 = (0, _context2.t1)(_context2.t2);
              _context2.next = 9;
              break;

            case 8:
              _context2.t0 = {
                value: undefined,
                done: true
              };

            case 9:
              return _context2.abrupt("return", _context2.t0);

            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    throw: function _throw(error) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(typeof iterator.throw === 'function')) {
                _context3.next = 6;
                break;
              }

              _context3.t0 = mapResult;
              _context3.next = 4;
              return iterator.throw(error);

            case 4:
              _context3.t1 = _context3.sent;
              return _context3.abrupt("return", (0, _context3.t0)(_context3.t1));

            case 6:
              throw error;

            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  }, Symbol.asyncIterator, function () {
    return this;
  });
}